export default "__VITE_ASSET__Byp4hYte__"